<template>
    <div class="page bg-gray page-flex">
        <backTitleBar></backTitleBar>
        <div class="flex1 posi-rel">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div v-for="(item,$index) in data" :key="$index" class="notice-item" >
                    <div class="time">{{item.createTime}}</div>
                    <div class="notice-content pd-25">
                        <div class="fs-34 color-333 font-bold">{{item.title}}</div>
                        <div class="mt-15 fs-28 color-999">
                            {{item.content}}
                        </div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import backTitleBar from "@/components/titleBar/backTitleBar"
    export default {
        name: "noticeList",
        mixins: [initData],
        components:{backTitleBar},
        data(){
            return{

            }
        },
        methods:{
            beforeInit() {
                this.params = { page : this.page, limit: this.limit};
                this.url = 'msg/msgAlertMessage/queryMyAlertMsg';
                return true
            },
        }
    }
</script>

<style scoped lang="scss">
    .notice-item{
        padding: 0 .24rem;
        .time{
            padding: .4rem 0 .24rem;
            text-align: center;
            font-size: .28rem;
            color: #999;
        }
        .notice-content{
            border-radius: .12rem;
            background: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// messageList.vue?28293e56